module.exports = __webpack_public_path__ + "static/media/Life.598bd486.svg";